import { isReactSnap } from 'modules/common/utils/isReactSnap';

import { BaseNavButton, NavigationProps } from './components/BaseNavButton';
import { CannyLinkWrapper } from './components/CannyLink';

export const Navigation = ({
  handleSidebarClose,
  isMobileSideBar,
  items,
}: NavigationProps) => {
  return (
    <nav>
      {items.map(item => {
        if (item.isCannyLink && !isReactSnap) {
          return (
            <CannyLinkWrapper
              key={item.label}
              item={item}
              isMobileSideBar={isMobileSideBar}
              handleSidebarClose={handleSidebarClose}
            />
          );
        }

        return (
          <BaseNavButton
            key={item.label}
            item={item}
            isMobileSideBar={isMobileSideBar}
            handleSidebarClose={handleSidebarClose}
          />
        );
      })}
    </nav>
  );
};
